// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3dOhj","unreadBadge":"styles_unreadBadge__16eQ_","modalContent":"styles_modalContent__2tMs_","modal":"styles_modal__1tvzj"};